import type { ParseKeys } from "i18next";
import { useTranslation } from "react-i18next";

import { showValidationErrors } from "@/utils";

export function useTranslateErrorObj() {
  const { t } = useTranslation("field");

  function getTranslatedErrorObj(errors: object): Record<string, string>;
  function getTranslatedErrorObj(
    errors: object,
    name: string,
  ): Record<string, string>;
  function getTranslatedErrorObj(
    errors: object,
    name: string[],
  ): Record<string, string>;
  function getTranslatedErrorObj(
    errors: object,
    name?: string | string[],
  ): Record<string, string> {
    const keys = Object.keys(errors);
    const errorObjTranslation: Record<string, string> = {};

    const addKey = (key: string, value: string) => {
      errorObjTranslation[t(key as ParseKeys<"field">)] = value;
    };

    for (const key of keys) {
      if (name === undefined) {
        // in this block we do not look for any specific name,
        // so we add any key into the obj.
        addKey(key, errors[key as keyof typeof errors]);
      } else if (typeof name === "string") {
        // in this case we get a specific name,
        // so we have to only add that key which is equal to the name.
        if (key === name) {
          addKey(key, errors[key as keyof typeof errors]);
          break;
        }
      } else if (name.includes(key)) {
        // in this case we have an array of names,
        // so we have to add only those which is in the array names.
        addKey(key, errors[key as keyof typeof errors]);
      }
    }

    return errorObjTranslation;
  }

  function notifyErrors(errors: object): void;
  function notifyErrors(errors: object, name: string): void;
  function notifyErrors(errors: object, name: string[]): void;
  function notifyErrors(errors: object, name?: string | string[]): void {
    let translatedObj = {};

    if (name === undefined) {
      translatedObj = getTranslatedErrorObj(errors);
    } else if (typeof name === "string") {
      translatedObj = getTranslatedErrorObj(errors, name);
    } else {
      translatedObj = getTranslatedErrorObj(errors, name);
    }
    showValidationErrors(translatedObj);
  }

  return { getTranslatedErrorObj, notifyErrors };
}
